import ReactDOM from "react-dom/client";

import Router from "@/router/index";
import { ConfigProvider, theme } from "antd";
import zhCN from 'antd/locale/zh_CN';
import React from "react";
import { Provider, useSelector } from 'react-redux'
import store from '@/store/index'
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');
import '@/utils/lang'
const Element = () => {

  const themePrimaryColor = useSelector((state) => {
    return state.theme.themePrimaryColor
  });

  return (
    <ConfigProvider locale={zhCN}
      theme={{
        // 全局主题，默认-defaultAlgorithm、黑色-darkAlgorithm、紧凑-compactAlgorithm
        algorithm: [theme.defaultAlgorithm],
        // 组件主题
        // components: {
        //   Button: {
        //     colorPrimary: '#eb2f96',
        //     algorithm: true, // 启用算法
        //   },
        //   Input: {
        //     colorPrimary: 'blue',
        //   }
        // },
        token: {
          // Seed Token
          // colorPrimary: '#1677ff',
          //themePrimaryColor || "#1677ff",
          borderRadius: 10,
          // 派生变量
          // colorBgContainer: 'white',
        },
      }}>
      <Router />
    </ConfigProvider>
  )
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <Element />
  </Provider>);
